import axios from 'axios'
import endpoint from "@/endpoint/endpoint";
const state = {
    roomAvailableData: [],
};

const mutations = {
    setRoomFoundData(state, data) {
        state.roomAvailableData = data;
    },
    loadRoomFoundData(state, data) {
        state.roomAvailableData = data;
    }
    ,
    resetRoomFoundData(state) {
        state.roomAvailableData = [];
    },
};

const actions = {
    saveRoomFound({ commit }, room_found) {
        commit('setRoomFoundData',room_found)
    },
    loadInitialData({commit, state}){
        if (state.roomAvailableData.length === 0) {
            setTimeout(()=>{
                console.log('load')
                axios.get(endpoint.LoadRoomAvailable).then((resp_room) => {
                    console.log(resp_room.data)
                    commit('loadRoomFoundData', resp_room.data);
                })
            },1000)
        }
        console.log("load initial data")
        console.log(state.roomAvailableData);
    },
    resetRoomFilterData({ commit }) {
        commit('resetRoomFoundData')
    },
};
const getters = {
    getRoomFoundData(state){
        return state.roomAvailableData
    }
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};